// Shared by the small consent bridge and the lazy Google integration.
// Do not change the browser URL: the shop still needs its seller attribution.
const sensitiveKey = /^(s|seller(?:_?(?:id|slug|code))?|ref|token(?:_hash)?|invite(?:_token)?|email|name|phone|address|buyer_.*|access_token|refresh_token|client_secret|payment_intent(?:_client_secret)?|order_?id|code|state|error(?:_code|_description)?|returnto|redirect_to|group|group_?id|organizationid)$/i;
export function sanitizeUrl(value) {
  try {
    const url = new URL(value, window.location.origin);
    url.hash = ''; url.username = ''; url.password = '';
    for (const [key, value] of [...url.searchParams]) {
      if (sensitiveKey.test(key) || /[@\r\n]|(?:access|refresh)_token|client_secret/i.test(value)) url.searchParams.delete(key);
    }
    return url.href;
  } catch { return ''; }
}
export const hasSellerLink = value => {
  try { return new URL(value, window.location.origin).searchParams.has('s'); } catch { return false; }
};
